export const STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "At Risk", value: "At Risk" },
  { label: "On Track", value: "On Track" },
  { label: "Completed", value: "Completed" },
];

export const ROLE_OPTIONS = [
  { label: "Superadmin", value: "superadmin" },
  { label: "Assistant Superadmin", value: "assistant_superadmin" },
  { label: "Manager", value: "manager" },
  { label: "Staff", value: "staff" },
  { label: "Visitor", value: "visitor" },
];
